var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4545 40.9091C31.7513 40.9091 40.9091 31.7513 40.9091 20.4545C40.9091 9.15781 31.7513 0 20.4545 0C9.15782 0 0 9.15781 0 20.4545C0 31.7513 9.15782 40.9091 20.4545 40.9091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4545 38.1054C30.2028 38.1054 38.1054 30.2028 38.1054 20.4545C38.1054 10.7063 30.2028 2.80374 20.4545 2.80374C10.7063 2.80374 2.80374 10.7063 2.80374 20.4545C2.80374 30.2028 10.7063 38.1054 20.4545 38.1054ZM40.9091 20.4545C40.9091 31.7513 31.7513 40.9091 20.4545 40.9091C9.15782 40.9091 0 31.7513 0 20.4545C0 9.15781 9.15782 0 20.4545 0C31.7513 0 40.9091 9.15781 40.9091 20.4545Z",
    fill: "#D3F1FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3633 21.0229C11.3633 20.0815 12.065 19.3184 12.9307 19.3184H27.9777C28.8434 19.3184 29.5451 20.0815 29.5451 21.0229C29.5451 21.9643 28.8434 22.7275 27.9777 22.7275H12.9307C12.065 22.7275 11.3633 21.9643 11.3633 21.0229Z",
    fill: "#75D7F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusWater);
export default __webpack_public_path__ + "static/media/minus_water.9eab361b4fa01334759e592945e85618.svg";
export { ForwardRef as ReactComponent };